import enAccount from '@/shared/i18n/messages/account/en.json';
import frAccount from '@/shared/i18n/messages/account/fr.json';
import mgAccount from '@/shared/i18n/messages/account/mg.json';
import enAdmin from '@/shared/i18n/messages/admin/en.json';
import frAdmin from '@/shared/i18n/messages/admin/fr.json';
import mgAdmin from '@/shared/i18n/messages/admin/mg.json';
import enAuth from '@/shared/i18n/messages/auth/en.json';
import frAuth from '@/shared/i18n/messages/auth/fr.json';
import mgAuth from '@/shared/i18n/messages/auth/mg.json';
import enCalls from '@/shared/i18n/messages/calls/en.json';
import frCalls from '@/shared/i18n/messages/calls/fr.json';
import mgCalls from '@/shared/i18n/messages/calls/mg.json';
import enCart from '@/shared/i18n/messages/cart/en.json';
import frCart from '@/shared/i18n/messages/cart/fr.json';
import mgCart from '@/shared/i18n/messages/cart/mg.json';
import enCatalog from '@/shared/i18n/messages/catalog/en.json';
import frCatalog from '@/shared/i18n/messages/catalog/fr.json';
import mgCatalog from '@/shared/i18n/messages/catalog/mg.json';
import enCommon from '@/shared/i18n/messages/common/en.json';
import frCommon from '@/shared/i18n/messages/common/fr.json';
import mgCommon from '@/shared/i18n/messages/common/mg.json';
import enCommunities from '@/shared/i18n/messages/communities/en.json';
import frCommunities from '@/shared/i18n/messages/communities/fr.json';
import mgCommunities from '@/shared/i18n/messages/communities/mg.json';
import enDisputes from '@/shared/i18n/messages/disputes/en.json';
import frDisputes from '@/shared/i18n/messages/disputes/fr.json';
import mgDisputes from '@/shared/i18n/messages/disputes/mg.json';
import enFeed from '@/shared/i18n/messages/feed/en.json';
import frFeed from '@/shared/i18n/messages/feed/fr.json';
import mgFeed from '@/shared/i18n/messages/feed/mg.json';
import enInspections from '@/shared/i18n/messages/inspections/en.json';
import frInspections from '@/shared/i18n/messages/inspections/fr.json';
import mgInspections from '@/shared/i18n/messages/inspections/mg.json';
import enLive from '@/shared/i18n/messages/live/en.json';
import frLive from '@/shared/i18n/messages/live/fr.json';
import mgLive from '@/shared/i18n/messages/live/mg.json';
import enMessaging from '@/shared/i18n/messages/messaging/en.json';
import frMessaging from '@/shared/i18n/messages/messaging/fr.json';
import mgMessaging from '@/shared/i18n/messages/messaging/mg.json';
import enNotifications from '@/shared/i18n/messages/notifications/en.json';
import frNotifications from '@/shared/i18n/messages/notifications/fr.json';
import mgNotifications from '@/shared/i18n/messages/notifications/mg.json';
import enOrders from '@/shared/i18n/messages/orders/en.json';
import frOrders from '@/shared/i18n/messages/orders/fr.json';
import mgOrders from '@/shared/i18n/messages/orders/mg.json';
import enPublish from '@/shared/i18n/messages/publish/en.json';
import frPublish from '@/shared/i18n/messages/publish/fr.json';
import mgPublish from '@/shared/i18n/messages/publish/mg.json';
import enSeller from '@/shared/i18n/messages/seller/en.json';
import frSeller from '@/shared/i18n/messages/seller/fr.json';
import mgSeller from '@/shared/i18n/messages/seller/mg.json';
import enShops from '@/shared/i18n/messages/shops/en.json';
import frShops from '@/shared/i18n/messages/shops/fr.json';
import mgShops from '@/shared/i18n/messages/shops/mg.json';
import enStock from '@/shared/i18n/messages/stock/en.json';
import frStock from '@/shared/i18n/messages/stock/fr.json';
import mgStock from '@/shared/i18n/messages/stock/mg.json';
import enUrgentRequests from '@/shared/i18n/messages/urgentRequests/en.json';
import frUrgentRequests from '@/shared/i18n/messages/urgentRequests/fr.json';
import mgUrgentRequests from '@/shared/i18n/messages/urgentRequests/mg.json';
import enWeb from '@/shared/i18n/messages/web/en.json';
import frWeb from '@/shared/i18n/messages/web/fr.json';
import mgWeb from '@/shared/i18n/messages/web/mg.json';

/**
 * Les traductions, rassemblées par langue.
 *
 * Un fichier par **espace de noms** et par langue : `common/fr.json`,
 * `orders/mg.json`… Chaque fichier porte son espace en clé racine, si bien que
 * l'assemblage se fait par simple étalement — l'espace de noms n'est jamais
 * répété dans le code, il est écrit une fois, dans le JSON.
 *
 * Le découpage suit les modules de `features/`, plus `common` pour ce qui
 * traverse toute l'application (actions, erreurs, formats, composants
 * partagés). Une clé se trouve donc là où vit l'écran qui l'affiche.
 *
 * Le français fait foi : c'est la langue dans laquelle l'application a été
 * écrite, et celle sur laquelle la vérification de parité aligne les deux
 * autres (`npm run i18n:check`).
 */
export const resources = {
  fr: {
    ...frCommon,
    ...frAccount,
    ...frAdmin,
    ...frAuth,
    ...frCalls,
    ...frCart,
    ...frCatalog,
    ...frCommunities,
    ...frDisputes,
    ...frFeed,
    ...frInspections,
    ...frLive,
    ...frMessaging,
    ...frNotifications,
    ...frOrders,
    ...frPublish,
    ...frSeller,
    ...frShops,
    ...frStock,
    ...frUrgentRequests,
    ...frWeb,
  },
  en: {
    ...enCommon,
    ...enAccount,
    ...enAdmin,
    ...enAuth,
    ...enCalls,
    ...enCart,
    ...enCatalog,
    ...enCommunities,
    ...enDisputes,
    ...enFeed,
    ...enInspections,
    ...enLive,
    ...enMessaging,
    ...enNotifications,
    ...enOrders,
    ...enPublish,
    ...enSeller,
    ...enShops,
    ...enStock,
    ...enUrgentRequests,
    ...enWeb,
  },
  mg: {
    ...mgCommon,
    ...mgAccount,
    ...mgAdmin,
    ...mgAuth,
    ...mgCalls,
    ...mgCart,
    ...mgCatalog,
    ...mgCommunities,
    ...mgDisputes,
    ...mgFeed,
    ...mgInspections,
    ...mgLive,
    ...mgMessaging,
    ...mgNotifications,
    ...mgOrders,
    ...mgPublish,
    ...mgSeller,
    ...mgShops,
    ...mgStock,
    ...mgUrgentRequests,
    ...mgWeb,
  },
};

/** Le bundle de référence : c'est lui qui type `t()` (voir `i18next.d.ts`). */
export type Messages = (typeof resources)['fr'];
